import { Separator, LayoutBand } from '@fs/zion-ui'

import React from 'react'

function PaddedLayoutBand({ children, bottomSeparatorSize = 'xl', topSeparatorSize = 'xl', ...props }) {
  return (
    <LayoutBand {...props}>
      <Separator size={topSeparatorSize} />
      {children}
      <Separator size={bottomSeparatorSize} />
    </LayoutBand>
  )
}

export default PaddedLayoutBand
